exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cluster-marker {\n    color: #fff;\n    background: #1978c8;\n    border-radius: 50%;\n    padding: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .terminal-marker {\n    background: none;\n    border: none;\n  }", ""]);

